module.exports = __webpack_public_path__ + "img/point-w.82ca00d7.svg";